import { React, useEffect, useState } from "react";
import API from '../../api/client';
import * as Config from '../../config/config';
import * as ENDPOINTS from '../../api/endpoints';
import { CustomerData } from "../utils/customers/CustomerData";
import noun_close_4213500 from '../../assets/images/noun_close_4213500.png';
import { getFieldByLangKey } from "../utils/LanguageField";
import { useTranslation } from 'react-i18next';
export default function Featured() {
    const customer = CustomerData.getCustomer();
    const [item, setItem] = useState([]);
    const [active, setActive] = useState(false);
    const imageUrl = Config.MEDIA_URL+Config.ANNOUNCEMENT_IMAGE_FOLDER;
    const { t } = useTranslation();
    useEffect( () => {
        const response = API.getWithToken(ENDPOINTS.GET_ANNONCEMENT_FEATURED);        
        response.then(res => { 
        if(res.statusText === 'OK') {
            setItem(res.data.data.announcement);
        }
        });
        
    }, []);

    const handleClick = () => {
        setActive(true)
      }
    
    const titleField = getFieldByLangKey('title');
    const textField = getFieldByLangKey('text');

    
    return (
        <>
            {item &&
                <div className={active ?"landing_popip announcement active":'landing_popip announcement'}>
                    <h3 data-field={getFieldByLangKey('title')}>
                        {t('dear_txt')} {customer && customer?.person_incharge}
                    </h3>
                    <p>{item[textField]}</p>
                    {item.image && (<img src={imageUrl+item.image} className="layer-33" alt={item[titleField]} width="223" height="151"/>)}
                    <a href="#" onClick={handleClick}>
                        <img src={noun_close_4213500}  className="noun_closed" alt={item[titleField]} width="17" height="17"/>
                    </a>                    
                </div>
            }
        </>
    );
}